<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :search="search"
      :loading="tableLoading"
      loading-text="Loading, please wait..."
      :page.sync="page"
      class="elevation-5"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
    >
      <template v-slot:top>
        <slot name="table-top"></slot>
      </template>
      <template v-slot:[`item.node.rankName`]="{ item }" v-if="isRankTable">
        <v-chip
          :color="item.node.rankColor"
          class="cursor-pointer"
          @click="openRankTab(item.node.rankName)"
        >
          {{ item.node.rankName }}
        </v-chip>
      </template>

      <template #[`item.action`]="{ item }">
        <slot name="table-actions" :actionItem="item"></slot>
      </template>
      <v-alert
        class="mt-4"
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableHeaders: {
      type: Array,
      required: true,
      default: () => [],
    },
    tableItems: {
      type: [Object, Array],
      required: true,
      default: () => [],
    },
    tableSearch: {
      type: String,
      required: true,
    },
    tableLoading: {
      type: Boolean,
      default: () => true,
    },
    isRankTable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 50,
      pageCount: 0,
    };
  },
  methods: {
    openRankTab(rankName) {
      const url = `/lib/standardsPivot/?profileName=SPORTECOS-SWIMMING&tab=pivotTable`; // Adjust base path as needed
      window.open(url, "_blank");
    },
  },
  computed: {
    search: {
      get() {
        return this.tableSearch;
      },
    },
  },
};
</script>
<style lang="scss">
.v-data-table {
  thead {
    tr {
      th {
        background: white !important;
      }
    }
  }
}
</style>
